import { render, staticRenderFns } from "./GImageCrop.vue?vue&type=template&id=33d2948a&scoped=true&"
import script from "./GImageCrop.vue?vue&type=script&lang=ts&"
export * from "./GImageCrop.vue?vue&type=script&lang=ts&"
import style0 from "./GImageCrop.vue?vue&type=style&index=0&id=33d2948a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d2948a",
  null
  
)

export default component.exports